import CLASS_NAMES from '../class-list';

const { CONTENT } = CLASS_NAMES;

export const contentMarkup: string = `
  <div class="${CONTENT}">

  </div>
`;




// WEBPACK FOOTER //
// ../node_modules/tslint-loader??ref--1!./modules/markup/content.ts